export const getTabs = (t: Function) => [
  {
    title: t('IPO'),
    type: 'radio',
    id: 'ipo-tab',
    name: 'tab-group',
  },
  {
    title: t('PRE-IPO'),
    type: 'radio',
    id: 'pre-ipo-tab',
    name: 'tab-group',
  },
];
